import React, { useState, useEffect } from 'react';

// Redux & Router
import { useDispatch } from 'react-redux';

// Internal Components & Utils
import EditorHeader from './EditorHeader';
import EditorContent from './EditorContent';
import EditorTimeline from './EditorTimeline';
import { clearEditHistory } from '@modules/editor';
import { setPlayTime, setSelectedPlayTime } from '@modules/media';
import '@resources/assets/styles/editor.scss';

function EditorTab() {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [videoDurationTime, setVideoDurationTime] = useState(0);

    useEffect(() => {
        dispatch(setPlayTime(0));
        dispatch(setSelectedPlayTime(0));
        dispatch(clearEditHistory());
    }, [dispatch]);

    return (
        <div className='container-editor'>
            <EditorHeader isLoading={isLoading} />

            <EditorContent
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setVideoDurationTime={setVideoDurationTime}
                videoDurationTime={videoDurationTime}
            />

            <EditorTimeline videoDurationTime={videoDurationTime} />
        </div>
    );
}

export default EditorTab;
